@if((admin || order?.orderStatusTypeID === 'Complete') && hasChanges()) {
  @if (order?.jurisdiction === '_F' && (order?.orderChanges?.length ?? 0) > 0) {
    <mat-card class="results-content card-margin">
      {{ 'uboChangeDetails.aDiscrepancyHasBeenNotedBetween' | transloco }}
    </mat-card>
  }
  @if(addressFieldChangesByAddress.length > 0 ||
    addRemoveAddresses.size > 0) {
    <mat-card class="results-content card-margin">

      <h3 class="section-title">{{ 'uboChangeDetails.addresses' | transloco }}</h3>

      @for(entry of addressFieldChangesByAddress; track entry) {
        @if(getFirstChangeNewFullValue(entry)) {
          <div class="flex-container-vertical-center">
            <mat-icon matTooltipClass="reghub-tooltip" [matTooltip]="getIconTooltip('add')"
            class="padding-right-15">add_circle_outline</mat-icon>
            <div class="flex-item-field-header">{{ getAddressType(entry.address.normalizedAddressType) }}:</div>
            <div class="flex-item-4-field-value">{{ getFirstChangeNewFullValue(entry) }}</div>
          </div>
        }
        @if (getFirstChangeOriginalFullValue(entry)) {
          <div class="flex-container-vertical-center">
            <mat-icon matTooltipClass="reghub-tooltip" [matTooltip]="getIconTooltip('remove')"
            class="padding-right-15">remove_circle_outline</mat-icon>
            <div class="flex-item-field-header">{{ getAddressType(entry.address.normalizedAddressType) }}:</div>
            <div class="flex-item-4-field-value">{{ getFirstChangeOriginalFullValue(entry) }}</div>
          </div>
        }
      }

      @for (entry of addRemoveAddresses; track entry[1]) {
        @if (isAdditionChange(entry[0])) {
          <div class="flex-container-vertical-center">
            <mat-icon matTooltipClass="reghub-tooltip" [matTooltip]="getIconTooltip('add')"
            class="padding-right-15">add_circle_outline</mat-icon>
            <div class="flex-item-field-header">{{ getAddressType(entry[1].normalizedAddressType) }}:</div>
            <div class="flex-item-4-field-value">{{ entry[1].fullAddress }}</div>
          </div>
        } @else if(isRemovalChange(entry[0])) {
          <div class="flex-container-vertical-center">
            <mat-icon matTooltipClass="reghub-tooltip" [matTooltip]="getIconTooltip('remove')"
            class="padding-right-15">remove_circle_outline</mat-icon>
            <div class="flex-item-field-header">{{ getAddressType(entry[1].normalizedAddressType) }}:</div>
            <div class="flex-item-4-field-value">{{ entry[1].fullAddress }}</div>
          </div>
        }
      }
    </mat-card>
  }

  @if(partyFieldChangesByParty.length > 0 ||
    addRemoveParties.size > 0) {
    <mat-card class="results-content card-margin">
      <h3 class="section-title">{{ 'common.labels.parties' | transloco }}</h3>

      @for (entry of partyFieldChangesByParty; track entry.index) {
        <div class="margin-bottom-15">
          <span class="flex-container-vertical-center bold"><mat-icon matTooltipClass="reghub-tooltip"
          [matTooltip]="getIconTooltip('replace')" class="padding-right-15">swap_horiz</mat-icon>
        {{ 'uboChangeDetails.updatedParty' | transloco }}</span>

        <!-- Normalized party type -->
        @if(hasChange(entry, 'normalizedPartyType')) {
          @if(getNewValue(entry, 'normalizedPartyType')) {
            <div class="flex-container-vertical-center">
              <mat-icon matTooltipClass="reghub-tooltip" [matTooltip]="getIconTooltip('add')"
              class="padding-right-15">add_circle_outline</mat-icon>
              <div class="flex-item-field-header">{{ 'common.labels.standardizedType' | transloco }}</div>
              <div class="flex-item-4-field-value">{{ getNewValue(entry, 'normalizedPartyType') }}</div>
            </div>
          }
          @if(getOriginalValue(entry, 'normalizedPartyType')) {
            <div class="flex-container-vertical-center">
              <mat-icon matTooltipClass="reghub-tooltip" [matTooltip]="getIconTooltip('remove')"
              class="padding-right-15">remove_circle_outline</mat-icon>
              <div class="flex-item-field-header">{{ 'common.labels.standardizedType' | transloco }}</div>
              <div class="flex-item-4-field-value">{{ getOriginalValue(entry, 'normalizedPartyType') }}</div>
            </div>
          }
        } @else if(entry.party.normalizedPartyType) {
          <div class="flex-container-vertical-center padding-left-field">
            <div class="flex-item">{{ 'common.labels.standardizedType' | transloco }}</div>
            <div class="flex-item-4">{{ (entry.party.normalizedPartyType | enumLabel:'normalizedPartyType') }}</div>
          </div>
        }
        <!-- End of normalied party type -->

        <!-- Party type -->
        @if(hasChange(entry, 'partyType')) {
          @if(getNewValue(entry, 'partyType')) {
            <div class="flex-container-vertical-center">
              <mat-icon matTooltipClass="reghub-tooltip" [matTooltip]="getIconTooltip('add')"
              class="padding-right-15">add_circle_outline</mat-icon>
              <div class="flex-item-field-header">{{ 'common.labels.registryType' | transloco }}</div>
              <div class="flex-item-4-field-value">{{ getNewValue(entry, 'partyType') }}</div>
            </div>
          }
          @if(getOriginalValue(entry, 'partyType')) {
            <div class="flex-container-vertical-center">
              <mat-icon matTooltipClass="reghub-tooltip" [matTooltip]="getIconTooltip('remove')"
              class="padding-right-15">remove_circle_outline</mat-icon>
              <div class="flex-item-field-header">{{ 'common.labels.registryType' | transloco }}</div>
              <div class="flex-item-4-field-value">{{ getOriginalValue(entry, 'partyType') }}</div>
            </div>
          }
        } @else if(entry.party.partyType) {
          <div class="flex-container padding-left-field">
            <div class="flex-item">{{ 'common.labels.registryType' | transloco }}</div>
            <div class="flex-item-4">{{ entry.party.partyType }}</div>
          </div>
        }
        <!-- End of party type -->

        <!-- Name -->
        @if(hasChange(entry, 'name')) {
          @if(getNewValue(entry, 'name')) {
            <div class="flex-container-vertical-center">
              <mat-icon matTooltipClass="reghub-tooltip" [matTooltip]="getIconTooltip('add')"
              class="padding-right-15">add_circle_outline</mat-icon>
              <div class="flex-item-field-header">{{ 'common.labels.name2' | transloco }}</div>
              <div class="flex-item-4-field-value">{{ getNewValue(entry, 'name') }}</div>
            </div>
          }
          @if(getOriginalValue(entry, 'name')) {
            <div class="flex-container-vertical-center">
              <mat-icon matTooltipClass="reghub-tooltip" [matTooltip]="getIconTooltip('remove')"
              class="padding-right-15">remove_circle_outline</mat-icon>
              <div class="flex-item-field-header">{{ 'common.labels.name2' | transloco }}</div>
              <div class="flex-item-4-field-value">{{ getOriginalValue(entry, 'name') }}</div>
            </div>
          }
        } @else if(entry.party.name) {
          <div class="flex-container padding-left-field">
            <div class="flex-item">{{ 'common.labels.name2' | transloco }}</div>
            <div class="flex-item-4">{{ entry.party.name }}</div>
          </div>
        }
        <!-- End of name -->

        <!-- Effective date -->
        @if(hasChange(entry, 'effectiveDate')) {
          @if(getNewValue(entry, 'effectiveDate')) {
            <div class="flex-container-vertical-center">
              <mat-icon matTooltipClass="reghub-tooltip" [matTooltip]="getIconTooltip('add')"
              class="padding-right-15">add_circle_outline</mat-icon>
              <div class="flex-item-field-header">{{ 'uboChangeDetails.effectiveDate' | transloco }}</div>
              <div class="flex-item-4-field-value">{{ getNewValue(entry, 'effectiveDate') | date: 'yyyy-MM-dd' }}</div>
            </div>
          }
          @if(getOriginalValue(entry, 'effectiveDate')) {
            <div class="flex-container-vertical-center">
              <mat-icon matTooltipClass="reghub-tooltip" [matTooltip]="getIconTooltip('remove')"
              class="padding-right-15">remove_circle_outline</mat-icon>
              <div class="flex-item-field-header">{{ 'uboChangeDetails.effectiveDate' | transloco }}</div>
              <div class="flex-item-4-field-value">{{ getOriginalValue(entry, 'effectiveDate') | date: 'yyyy-MM-dd' }}
              </div>
            </div>
          }
        } @else if(entry.party.effectiveDate) {
          <div class="flex-container padding-left-field">
            <div class="flex-item">{{ 'uboChangeDetails.effectiveDate' | transloco }}</div>
            <div class="flex-item-4">{{ entry.party.effectiveDate | date: 'yyyy-MM-dd' }}</div>
          </div>
        }
        <!-- End of effective date -->

        <!-- End date -->
        @if(hasChange(entry, 'endDate')) {
          @if(getNewValue(entry, 'endDate')) {
            <div class="flex-container-vertical-center">
              <mat-icon matTooltipClass="reghub-tooltip" [matTooltip]="getIconTooltip('add')"
              class="padding-right-15">add_circle_outline</mat-icon>
              <div class="flex-item-field-header">{{ 'uboChangeDetails.endDate' | transloco }}</div>
              <div class="flex-item-4-field-value">{{ getNewValue(entry, 'endDate') | date: 'yyyy-MM-dd' }}</div>
            </div>
          }
          @if(getOriginalValue(entry, 'endDate')) {
            <div class="flex-container-vertical-center">
              <mat-icon matTooltipClass="reghub-tooltip" [matTooltip]="getIconTooltip('remove')"
              class="padding-right-15">remove_circle_outline</mat-icon>
              <div class="flex-item-field-header">{{ 'uboChangeDetails.endDate' | transloco }}</div>
              <div class="flex-item-4-field-value">{{ getOriginalValue(entry, 'endDate') | date: 'yyyy-MM-dd' }}</div>
            </div>
          }
        } @else if(entry.party.endDate) {
          <div class="flex-container padding-left-field">
            <div class="flex-item">{{ 'uboChangeDetails.endDate' | transloco }}</div>
            <div class="flex-item-4">{{ entry.party.endDate | date: 'yyyy-MM-dd' }}</div>
          </div>
        }
        <!-- End of end date -->

        <!-- Addresses -->
        @if(entry.addressChanges.length > 0) {
          @for(addressChange of entry.addressChanges; track addressChange) {
            @if(isAdditionChange(addressChange.changes[0])) {
              <div class="flex-container-vertical-center">
                <mat-icon matTooltipClass="reghub-tooltip" [matTooltip]="getIconTooltip('add')"
                class="padding-right-15">add_circle_outline</mat-icon>
                <div class="flex-item-field-header">{{ getAddressType(addressChange.address.normalizedAddressType)
                }}</div>
                <div class="flex-item-4-field-value">{{ addressChange.address.fullAddress}}</div>
              </div>
            } @else if(isRemovalChange(addressChange.changes[0])) {
              <div class="flex-container-vertical-center">
                <mat-icon matTooltipClass="reghub-tooltip" [matTooltip]="getIconTooltip('remove')"
                class="padding-right-15">remove_circle_outline</mat-icon>
                <div class="flex-item-field-header">{{ getAddressType(addressChange.address.normalizedAddressType)
                }}</div>
                <div class="flex-item-4-field-value">{{ addressChange.address.fullAddress}}</div>
              </div>
            } @else {
              @if(getFirstChangeNewFullValue(addressChange)) {
                <div class="flex-container-vertical-center">
                  <mat-icon matTooltipClass="reghub-tooltip" [matTooltip]="getIconTooltip('add')"
                  class="padding-right-15">add_circle_outline</mat-icon>
                  <div class="flex-item-field-header">{{ getAddressType(addressChange.address.normalizedAddressType)
                  }}</div>
                  <div class="flex-item-4-field-value">{{ getFirstChangeNewFullValue(addressChange) }}</div>
                </div>
              }
              @if(getFirstChangeOriginalFullValue(addressChange)) {
                <div class="flex-container-vertical-center">
                  <mat-icon matTooltipClass="reghub-tooltip" [matTooltip]="getIconTooltip('remove')"
                  class="padding-right-15">remove_circle_outline</mat-icon>
                  <div class="flex-item-field-header">{{ getAddressType(addressChange.address.normalizedAddressType)
                  }}</div>
                  <div class="flex-item-4-field-value">{{ getFirstChangeOriginalFullValue(addressChange) }}</div>
                </div>
              }
            }
          }
        }
        <!-- End of addresses -->
      </div>
    }

    @for (entry of addRemoveParties; track entry[1]) {
      <div class="margin-bottom-15">
        @if(isAdditionChange(entry[0])) {
          <span class="flex-container-vertical-center bold"><mat-icon matTooltipClass="reghub-tooltip"
          [matTooltip]="getIconTooltip('add')" class="padding-right-15">add_circle_outline</mat-icon>
        {{ 'uboChangeDetails.addedParty' | transloco }}</span>
      } @else if(isRemovalChange(entry[0])) {
        <span class="flex-container-vertical-center bold"><mat-icon matTooltipClass="reghub-tooltip"
        [matTooltip]="getIconTooltip('remove')" class="padding-right-15">remove_circle_outline</mat-icon>{{ 'uboChangeDetails.removedParty' | transloco }}</span>
    }
    <div class="flex-container padding-left-field">
      <div class="flex-item">{{ 'common.labels.standardizedType' | transloco }}</div>
      <div class="flex-item-4">{{ (entry[1].normalizedPartyType | enumLabel:'normalizedPartyType') }}</div>
    </div>
    @if(entry[1].partyType) {
      <div class="flex-container padding-left-field">
        <div class="flex-item">{{ 'common.labels.registryType' | transloco }}</div>
        <div class="flex-item-4">{{ entry[1].partyType }}</div>
      </div>
    }
    @if(entry[1].name) {
      <div class="flex-container padding-left-field">
        <div class="flex-item">{{ 'common.labels.name2' | transloco }}</div>
        <div class="flex-item-4">{{ entry[1].name }}</div>
      </div>
    }
    @if(entry[1].effectiveDate) {
      <div class="flex-container padding-left-field">
        <div class="flex-item">{{ 'uboChangeDetails.effectiveDate' | transloco }}</div>
        <div class="flex-item-4">{{ entry[1].effectiveDate | date: 'yyyy-MM-dd' }}</div>
      </div>
    }
    @if(entry[1].endDate) {
      <div class="flex-container padding-left-field">
        <div class="flex-item">{{ 'uboChangeDetails.endDate' | transloco }}</div>
        <div class="flex-item-4">{{ entry[1].endDate | date: 'yyyy-MM-dd' }}</div>
      </div>
    }
    @if(entry[1].addresses.length > 0) {
      @for (address of entry[1].addresses; track address) {
        <div class="flex-container padding-left-field">
          <div class="flex-item">{{ getAddressType(address.normalizedAddressType )}}:</div>
          <div class="flex-item-4">{{ address.fullAddress }}</div>
        </div>
      }
    }
  </div>
}
</mat-card>
}
} @else if(!admin && order?.orderStatusTypeID !== 'Complete') {
  <mat-card class="results-content card-margin text-faded">
    {{ 'uboChangeDetails.thisSectionWillPopulateWhenThe' | transloco }}
  </mat-card>
} @else {
  <mat-card class="results-content card-margin text-faded">
    {{ 'uboChangeDetails.noUpdatesWereProvidedByThe' | transloco }}
  </mat-card>
}